export class InverterFilterOptions {
    manufacturer: string[];
    modelNumber: string[];
    versionNumber: string[];
    phaseType: string[];
    inverterPhaseConnection: string[];
}